/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

export enum DisplayType {
	DISPLAY_TYPE_NONE = 'DISPLAY_TYPE_NONE',
	DISPLAY_TYPE_PHONE_NUMBER = 'DISPLAY_TYPE_PHONE_NUMBER',
	DISPLAY_TYPE_PERSONAL_NAME = 'DISPLAY_TYPE_PERSONAL_NAME',
	DISPLAY_TYPE_ENTER_PASSWORD = 'DISPLAY_TYPE_ENTER_PASSWORD'
}
